import {FAMILY_GROUP_MENU_HEADER_PAYLOAD} from '../Types/types'


export function menuHeaderPayload(data: any) {
  return {
    type: FAMILY_GROUP_MENU_HEADER_PAYLOAD,
    payload: data
  }
}